var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSave24Dp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2-2h22v22H-2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.583.75h-11A1.833 1.833 0 00.75 2.583v12.834c0 1.008.816 1.833 1.833 1.833h12.834a1.839 1.839 0 001.833-1.833v-11L13.583.75zm1.834 14.667H2.583V2.583h10.24l2.594 2.595v10.239zM9 9a2.746 2.746 0 00-2.75 2.75A2.746 2.746 0 009 14.5a2.746 2.746 0 002.75-2.75A2.746 2.746 0 009 9zM3.5 3.5h8.25v3.667H3.5V3.5z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
export default SvgSave24Dp;